<template>
  <div class="waitTask">
    <div class="content-top">
      <i-select v-model="problemId" style="width:2rem" @on-change="changeList">
        <Option :value= '0'>全部</Option>
        <Option v-for="item in problemList" :key="item.index" :value='item.type_id'>{{item.type_name}}</Option>
      </i-select>
      <i-input search class="search" v-model.trim="content" @on-search="searchKeyword" placeholder="请输入问题描述关键词"> </i-input>
    </div>
    <div class="content">
      <Table border :columns="waitList" :data="dealProblemList.list"></Table>
      <Page :current="this.page" :total="dealProblemList.total" @on-change="changePage" style="margin-top: 0.1rem;float: right"/>
    </div>
  </div>
</template>

<script>
import {getProblemIndex, getProblemList} from '../../../api/api'
export default
{
  name: 'waitTask',
  mounted () {
    this.init()
    // 获取实时总数
    localStorage.setItem = (key, newValue) => {
      if (key === 'waitTotal') {
        let setItemEvent1 = new Event('setItemEvent1')
        setItemEvent1.newValue = newValue
        window.dispatchEvent(setItemEvent1)
        localStorage.setItem.apply(this, arguments)
      } else if (key === 'processedTotal') {
        let setItemEvent2 = new Event('setItemEvent2')
        setItemEvent2.newValue = newValue
        window.dispatchEvent(setItemEvent2)
        localStorage.setItem.apply(this, arguments)
      }
    }
  },
  data () {
    return {
      waitList: [
        {
          title: '问题类型',
          key: 'type_name',
          align: 'center'
        },
        {
          title: '问题描述',
          key: 'content',
          align: 'center',
          ellipsis: true
        },
        {
          title: '状态',
          key: 'status',
          align: 'center'
        },
        {
          title: '提交人',
          key: 'pname',
          align: 'center'
        },
        {
          title: '提交时间',
          key: 'pdate',
          align: 'center'
        },
        {
          title: '操作',
          key: 'action',
          width: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'success'
                },
                style: {
                  backgroundColor: '#15bc41'
                },
                on: {
                  click: () => {
                    this.show1(params.row)
                  }
                }
              }, '查看详情')
            ])
          }
        }
      ],
      waitType: 0,
      problemList: [],
      content: null,
      status: '',
      page: 1,
      dealProblemList: [],
      problemId: 0,
      articleType: 0
    }
  },
  methods: {
    async init () {
      let index = parseInt(sessionStorage.getItem('selectId'))
      await this.getMatterType()
      await this.changeList(index)
    },
    async getMatterType () {
      const res = await getProblemList()
      if (res.code === 0) {
        if (res.data !== null) {
          this.problemList = res.data
        } else {
          this.problemList = []
        }
      }
    },
    async getDealProbelms () {
      let data = {
        tid: this.problemId,
        content: this.content,
        status: 0,
        page: this.page
      }
      const res = await getProblemIndex(data)
      if (res.code === 0) {
        if (res.data !== null) {
          this.dealProblemList = res.data
          this.dealProblemList.list.forEach((element, index) => {
            this.dealProblemList.list[index].status = '待处理'
          })
          this.page = this.dealProblemList.page
          localStorage.setItem('waitTotal', res.data.total)
        } else {
          this.dealProblemList.list = []
          this.page = 1
          this.$Message.info('无相关数据')
          localStorage.setItem('waitTotal', 0)
        }
      }
    },
    async getDealProbelms2 () {
      let data = {
        tid: this.problemId,
        content: this.content,
        status: 1,
        page: this.page
      }
      const res = await getProblemIndex(data)
      if (res.code === 0) {
        if (res.data !== null) {
          window.localStorage.setItem('processedTotal', res.data.total)
        } else {
          window.localStorage.setItem('processedTotal', 0)
        }
      }
    },
    changeList (index) { // 下拉列表选择
      this.problemId = index
      sessionStorage.setItem('selectId', index)
      this.getDealProbelms()
      this.getDealProbelms2()
    },
    // 关键字搜索
    searchKeyword () {
      if (this.content === '') {
        this.content = null
        this.getDealProbelms()
      } else {
        this.getDealProbelms()
      }
    },
    // 页码选择
    changePage (index) {
      this.page = index
      this.getDealProbelms()
    },
    show1 (id) { // 文章详情
      sessionStorage.setItem('articleId', id.id)
      this.waitType = 1
      sessionStorage.setItem('waitType', this.waitType)
      sessionStorage.setItem('articleType', this.articleType)
      this.$router.push('waitParticular')
    }
  }
}
</script>

<style scoped lang="stylus">
.waitTask
  .content-top
    .ivu-input-wrapper .ivu-input-wrapper-default .ivu-input-type
      border-radius 0.1rem
    .search
      width:2.3rem
      margin-left: .2rem
  .content
    padding-top .2rem
</style>



// WEBPACK FOOTER //
// src/views/feedback/child/waitTask.vue